module.exports = __webpack_public_path__ + "static/media/enrol-bg.f8304c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enrol-bg.png
// module id = 1009
// module chunks = 0